import { each, find } from "lodash";
import {
  Activitystream,
  useActivitystreams,
} from "../../../api/activitystreams.ts";

export default function useActivitystreamsFromSlugs({
  slugs,
  includeSubscriberCount,
}: {
  slugs: string[];
  includeSubscriberCount?: boolean;
}) {
  const { data: streams } = useActivitystreams({
    includeSubscriberCount,
  });

  if (!streams) return undefined;

  const streamsFromSlugs: Activitystream[] = [];

  each(slugs, (slug) => {
    const activitystream = find(streams, (stream) => stream.slug === slug);

    if (activitystream) streamsFromSlugs.push(activitystream);
  });

  return streamsFromSlugs;
}
